import addMinutes from 'date-fns/addMinutes';

export const utcToLocal = (date: Date): Date => {
  const tzOffset = date.getTimezoneOffset();

  return addMinutes(date, -tzOffset);
};
